// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "questionsAnswers-1Zjyt";
var _4 = "questionsAnswers__title-3iyFQ";
var _5 = "questionsAnswers__content-2DDyD";
export { _1 as "__esModule", _2 as "mobile", _3 as "questionsAnswers", _4 as "questionsAnswers__title", _5 as "questionsAnswers__content" }
export default { "__esModule": _1, "mobile": _2, "questionsAnswers": _3, "questionsAnswers__title": _4, "questionsAnswers__content": _5 }
